import { render, staticRenderFns } from "./table_config_column_batchsetting.vue?vue&type=template&id=beb92132"
import script from "./table_config_column_batchsetting.vue?vue&type=script&lang=js"
export * from "./table_config_column_batchsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports